// extracted by css-extract-rspack-plugin
export default {"cluster":"AvatarCluster-module__cluster","avatar":"AvatarCluster-module__avatar","photo":"AvatarCluster-module__photo","presence":"AvatarCluster-module__presence"};